
interface SearchSeoParams {
  query?: string;
  categoryName?: string;
  location?: string;
  minPrice?: number;
  maxPrice?: number;
  resultsCount?: number;
  sortBy?: string;
  filters?: {
    make?: string;
    minYear?: number;
    maxYear?: number;
    condition?: string;
    transportOption?: string;
  };
}

export function generateSearchSeoTitle(params: SearchSeoParams): string {
  const { query, categoryName, location, minPrice, maxPrice, sortBy, filters } = params;
  
  let title = '';
  
  if (query) {
    title = `${query}`;
  } else if (categoryName) {
    title = categoryName;
  } else {
    title = 'Produktet';
  }
  
  // Add location context
  if (location) {
    title += ` në ${location}`;
  }
  
  // Add price range if specified
  if (minPrice && maxPrice) {
    title += ` ${minPrice}-${maxPrice}€`;
  } else if (minPrice) {
    title += ` nga ${minPrice}€`;
  } else if (maxPrice) {
    title += ` deri ${maxPrice}€`;
  }
  
  // Add condition filter
  if (filters?.condition) {
    title += ` ${filters.condition === 'new' ? 'të ri' : 'të përdorur'}`;
  }
  
  // Add vehicle make if searching in vehicles
  if (filters?.make) {
    title += ` ${filters.make}`;
  }
  
  title += ' - TreguIm';
  
  return title.length > 60 ? title.substring(0, 57) + '...' : title;
}

export function generateSearchSeoDescription(params: SearchSeoParams): string {
  const { query, categoryName, location, minPrice, maxPrice, resultsCount, filters } = params;
  
  let description = 'Shesblej dhe merrjep ';
  
  if (query) {
    description += `"${query}"`;
  } else if (categoryName) {
    description += categoryName.toLowerCase();
  } else {
    description += 'produktet më të mira';
  }
  
  if (location) {
    description += ` në ${location}`;
  }
  
  description += ` në TreguIm. ${resultsCount} njoftime të disponueshme`;
  
  if (minPrice || maxPrice) {
    description += ' me çmime ';
    if (minPrice && maxPrice) {
      description += `nga ${minPrice}€ deri ${maxPrice}€`;
    } else if (minPrice) {
      description += `nga ${minPrice}€`;
    } else {
      description += `deri ${maxPrice}€`;
    }
  }
  
  if (filters?.condition) {
    description += `, ${filters.condition === 'new' ? 'të ri' : 'të përdorur'}`;
  }
  
  description += '. Celsi shitje dhe blerje e sigurt online.';
  
  return description.length > 160 ? description.substring(0, 157) + '...' : description;
}

export function createSearchStructuredData(params: Pick<SearchSeoParams, 'query' | 'categoryName' | 'location' | 'resultsCount'>) {
  const { query, categoryName, location, resultsCount } = params;
  
  return {
    "@context": "https://schema.org",
    "@type": "SearchResultsPage",
    "name": `Rezultatet e kërkimit për ${query || categoryName || 'produktet'}`,
    "description": `${resultsCount} produkte të gjetura në TreguIm`,
    "url": typeof window !== 'undefined' ? window.location.href : 'https://treguim.org/search',
    "mainEntity": {
      "@type": "ItemList",
      "numberOfItems": resultsCount,
      "itemListElement": []
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://treguim.org/search?q={search_term}",
      "query-input": "required name=search_term"
    }
  };
}
